const getCurrentSiteBusinessUnit = () => {
  return process.env.NEXT_PUBLIC_BUSINESS_UNIT
}

export default getCurrentSiteBusinessUnit
